'use client'
import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

import Loading from '@/components/feature/Loading'
import { determineLocale } from '@/lib/determineLocale'

const Home = () => {
	const router = useRouter()

	useEffect(() => {
		const locale = determineLocale()
		router.replace(`/${locale}`)
	}, [])

	return (
		<div className="center" style={{ width: '100%', height: '100vh' }}>
			<Loading />
		</div>
	)
}
export default Home
